import React from 'react';
/* Helpers */
import utils from '../../../modules/utils.js'

const BoxFiliale = ({ key, branch, isOpen, openedMap, functions }) => {
  const { prodotto } = utils.getState();
  const { idFiliale: id, nomeFiliale: name, indirizzo: address, cap, citta: city, disponibilita: hours, coordinate: coordinates} = branch
  const { setDataAndGo, apriFiliale, filialeHasData, getDisponibilita, openMap } = functions;
  let openClass = 'open';

  const renderOrario = (orario) => {
    if (orario) {
      let orario_str = utils.padLeft(orario.hour) + ":" + utils.padLeft(orario.minute);
      let o_obj = {
        'orario': orario_str,
        'disponibile': orario.disponibile
      }
      return (
        <div key={orario_str} className={'orario ' + (orario.disponibile ? 'disponibile' : '')} onClick={setDataAndGo.bind(this, o_obj)}>
          <div className="contenuto">
            {orario_str}
          </div>
        </div>
      )
    }

    return null;
  }
  
  const renderBox = (availableSlotsList = []) => {
    return (<div key={key} className={`filiale-box cell gsap-slide ${isOpen ? "open" : ""}`} nome={name} id_filiale={id} indirizzo={address}>
    <div className="controllore" onClick={apriFiliale}>
      <svg className="opener" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 5.5L9 12.5L16 5.5" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <svg className="closer" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.05029 4.0498L13.9498 13.9493" stroke="#333333" strokeWidth="2" strokeLinecap="round" />
        <path d="M4.05037 13.9493L13.9499 4.0498" stroke="#333333" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>

    <h3 onClick={apriFiliale}>
      {name}
    </h3>

    <p className="indirizzo" onClick={apriFiliale}>
      {address} - {cap} {city}
    </p>

    <div className="dettagliFiliale">
      <div className="contenuto">
        <div className={'filialeLoader ' + (filialeHasData(id) ? 'caricata' : '')}>
          <img src="./img/Loader_rosso.gif" />
        </div>
        { 
          availableSlotsList.length ?
            availableSlotsList.map(slot => renderOrario(slot)) : 
            getDisponibilita(hours).map(slot => renderOrario(slot))
        }
        <div className="clear"></div>
        <div className={'area_mappa' + ' ' + (openedMap == id ? 'open' : '')}>
          <label className={'mostra'} data-filiale={id} data-lat={coordinates.lat} data-lng={coordinates.lng} onClick={openMap}>Mostra mappa</label>
          <label className={'nascondi'} data-filiale={id} data-lat={coordinates.lat} data-lng={coordinates.lng} onClick={openMap}>Nascondi mappa</label>
          <div className={'box_mappa'} data-filiale={id}>
            <div className="contenuto_mappa"></div>
          </div>
        </div>
      </div>
    </div>
  </div>);
  }

  if (prodotto == 3) {
    const availableSlotsList = getDisponibilita(hours);

    if (availableSlotsList.length) {
      return renderBox(availableSlotsList);
    } else {
      return null;
    }
  }

  return renderBox();
}

export default BoxFiliale;


// WEBPACK FOOTER //
// ./src/components/shared/BoxFiliale/index.js